<template>
	<div>
		<div v-if="news.open_type == 1">
			<div class="container">
				<div class="row clearfix">
					<div class="column full p-0">
						<h3 class="iv2-news-detail__title" style="text-align: left;">{{ news.title }}</h3>
						<hr />
						<div class="iv2-news-detail__subtitle">
							<p v-if="news.opened_at !== null">{{ news.opened_at | moment }}</p>
							<p class="iv2-news-detail__label mx-0">{{ news.category_name }}</p>
						</div>
					</div>
					<div class="column full">
						<div class="spacer height-40"></div>
					</div>
				</div>
			</div>

			<div class="container-fluid" v-html="news.content"></div>
			<div class="spacer height-40"></div>
		</div>

		<div v-else>
			<div class="column full">
				<div class="py-3">
					<h4 class="size-28 text-center">{{ $t('news.null_title') }}</h4>
				</div>
			</div>
		</div>

		<div class="container">
			<div class="row clearfix">
				<div class="column full">
					<div class="text-center">
						<span>
							<router-link to="/news" class="iv2-news-detail__btn theme__main-btn is-btn is-btn-ghost2 size-18"
							>{{ $t('news.list_button') }}</router-link>
						</span>
					</div>
					<div class="spacer height-100"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";

export default {
	props: ["news"],

	filters: {
		moment: function (created) {
			return moment(created).format("YYYY年MM月DD日");
		},
	},
};
</script>

<style lang="scss">
.iv2-news-detail__subtitle {
	display: flex;
	justify-content: space-between;
	
	.iv2-news-detail__label {
		padding: 0 20px;
		margin: 15px 20px;
		border: 1px solid;
	}
}

.iv2-news-detail__btn {
	border: 0;
	letter-spacing: 2px;
	width: 300px;
	max-width: 100%;
	padding-top: 15px;
	padding-bottom: 15px;
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-news-detail__title {
		font-size: 1.5rem;
	}
}
/* SP Only */
@media (max-width: 767px) {
	.iv2-news-detail__title {
		font-size: 1.3rem;
	}
}
</style>